import { Field } from 'redux-form';

import { TextField } from 'common/components/forms';

const NameFields = (props) => {
  const { hasNameFields } = props;
  if (!hasNameFields) {
    return null;
  }
  return (
    <>
      <div className="c7-form__group">
        <Field
          name="firstName"
          component={TextField}
          label="First Name"
          autocomplete="given-name"
          required
        />
        <Field
          name="lastName"
          component={TextField}
          label="Last Name"
          autocomplete="family-name"
          required
        />
      </div>
    </>
  );
};

export default NameFields;
